module.exports = __webpack_public_path__ + "img/N550-1-EN.5e08e1a1.png";